import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Box, Typography, Card, CardContent } from "@mui/material";
import FlagCircleIcon from "@mui/icons-material/FlagCircle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTranslation } from "react-i18next";

export function Callback() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/dashboard", { replace: true });
    }, 1500);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "70vh",
      }}
    >
      <Card sx={{ maxWidth: 420, textAlign: "center" }}>
        <CardContent sx={{ p: 5 }}>
          <Box sx={{ position: "relative", display: "inline-block", mb: 2 }}>
            <FlagCircleIcon color="primary" sx={{ fontSize: 64 }} />
            <CheckCircleIcon
              color="success"
              sx={{ fontSize: 28, position: "absolute", bottom: -4, right: -8 }}
            />
          </Box>
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              fontWeight: 700,
            }}
          >
            {t("callback.welcomeBack")}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              mb: 3,
            }}
          >
            {t("callback.redirecting")}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
            }}
          >
            {t("callback.stuck")}{" "}
            <Link to="/login" style={{ color: "inherit" }}>
              {t("callback.returnToLogin")}
            </Link>
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
